const RoomSimple = () => import(/* webpackChunkName: "page-room-simple" */ '@/components/pages/room_simple/Index.vue')

export default [
  // 部屋編集
  {
    path: '/edit/room/:roomId/simple',
    component: RoomSimple,
    name: 'room-simple-edit',
    meta: {
      title: '部屋編集',
      type: 'edit',
      auth: null,
    },
  },
  // 部屋コピー
  {
    path: '/copy/building/:buildingId/room/:roomId/type/:typeId/simple',
    component: RoomSimple,
    name: 'room-simple-copy',
    meta: {
      title: '部屋コピー',
      type: 'copy',
      auth: null,
    },
  },
]
